<template>
  <v-card :key="mode">
    <!-- navigation tabs -->
    <v-card class="d-flex justify-center align-center">
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="mode !== 'new' ? true : false">Persona</v-tab>
          <v-tab :disabled="!object">Comercial</v-tab>
        </v-tabs>
      </div>
    </v-card>

    <!-- person search only for new registers -->
    <person
      v-if="currentTab === 0 && mode === 'new'"
      @itemSelected="personSelected($event)"
      :enableManual="enabledPersonManual"
    ></person>

    <!-- commercialPerson data -->
    <v-card-text v-if="currentTab === 1 && object">
      <v-card>
        <v-card class="mb-2">
          <v-card-title>
            Persona
          </v-card-title>
          <v-card-text>
            <v-text-field
              disabled
              label="Nombre"
              id="person_name"
              v-model="object.person_name"
            ></v-text-field>
            <v-text-field
              disabled
              label="Tipo Identificación"
              id="person_identification_type_description"
              v-model="object.person_identification_type_description"
            ></v-text-field>
            <v-text-field
              disabled
              label="Identificación"
              id="person_identification"
              v-model="object.person_identification"
            ></v-text-field>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title>
            Datos del Comercial
          </v-card-title>
          <v-card-text>
            <!-- eslint-disable -->
            <v-select
              :disabled="!editing"
              :items="commercialPersonTypes"
              item-text="description"
              item-value="url"
              v-model="object.commercial_person_type"
              label="Tipo"
              @change="CommercialPersonTypeChange($event)"
            ></v-select>
            <!-- superior -->
            <div class="d-flex align-center">
              <v-text-field
                disabled
                :value="
                  object.superior
                    ? object.superior_commercial_person_type_description +
                      ' - ' +
                      object.superior_person_name
                    : null
                "
                label="Superior"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing && current_level <= 2 ? 'enabled-icon' : 'disabled-icon'"
                  v-show="editing && current_level <= 2"
                  @click="superiorClick"
                >
                  {{ !object.superior ? "mdi-magnify" : "mdi-trash-can-outline" }}
                </v-icon>
              </v-text-field>
            </div>
            <v-text-field
              label="email"
              id="email"
              v-model="object.email"
              :disabled="!editing"
              @input="v => { object.email = v.toLowerCase()}"
            ></v-text-field>
            <v-text-field
              v-show="object.commercial_person_type_level === 3"
              label="Teléfono"
              id="phone_number"
              v-model="object.phone_number"
              :disabled="!editing"
              type="number"
            ></v-text-field>
            <!-- Habilitado -->
            <v-switch
              :disabled="!editing"
              v-model="object.can_authenticate"
              inset
              label="Habilitado para uso del sistema"
            ></v-switch>
            <!-- Puede editar estimados de venta -->
            <v-switch
              v-show="object.commercial_person_type_level > 3"
              :disabled="!editing"
              v-model="object.can_estimate_sale"
              inset
              label="Habilitado para mantenimiento de estimados de venta"
            ></v-switch>
            <!-- Puede visualizar Pedidos -->
            <v-switch
              v-show="
                object.commercial_person_type_level === 3 ||
                (object.commercial_person_type_level === 4 && object.superior_can_view_orders == true)
              "
              :disabled="!editing"
              v-model="object.can_view_orders"
              inset
              label="Habilitado para visualizar Notas de Venta"
            ></v-switch>
            <!-- Puede editar Notas de Venta -->
            <v-switch
              v-show="
                object.commercial_person_type_level === 3 ||
                (object.commercial_person_type_level === 4 && object.superior_can_edit_orders == true)
              "
              :disabled="!editing"
              v-model="object.can_edit_orders"
              inset
              label="Habilitado para editar Notas de Venta"
            ></v-switch>
            <!-- Accede a Cotizaciones -->
            <v-switch
              v-show="
                object.commercial_person_type_level === 3 ||
                (object.commercial_person_type_level === 4 && object.superior_can_access_quotations == true)
              "
              :disabled="!editing"
              v-model="object.can_access_quotations"
              inset
              label="Habilitado para acceso a Cotizaciones"
            ></v-switch>
            <!-- eslint-enable -->
            <!-- Cliente -->
            <div
              v-if="object.commercial_person_type_requires_client === true"
              class="d-flex align-center"
            >
              <v-text-field
                disabled
                :value="
                  object.client
                    ? object.client_code + ' - ' + object.client_name
                    : null
                "
                label="Cliente"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  v-show="editing"
                  @click="clientClick"
                >
                  {{ !object.client ? "mdi-magnify" : "mdi-trash-can-outline" }}
                </v-icon>
              </v-text-field>
            </div>
            <!-- Salesman -->
            <div
              v-if="object.commercial_person_type_requires_salesman === true"
              class="d-flex align-center"
            >
              <v-text-field
                disabled
                :value="
                  object.salesman
                    ? object.salesman_code + ' - ' + object.salesman_description
                    : null
                "
                label="Vendedor"
              >
                <!-- eslint-disable -->
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  v-show="editing"
                  @click="salesmanClick"
                >
                  {{ !object.salesman ? "mdi-magnify" : "mdi-trash-can-outline" }}
                </v-icon>
                <!-- eslint-enable -->
              </v-text-field>
            </div>
          </v-card-text>
        </v-card>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="showSuperior || showSalesman || showClient"
      :show="showSuperior || showSalesman || showClient"
      :title="searchOptions.title"
      :endpoint="searchOptions.endpoint"
      :ordering="searchOptions.ordeting"
      :searchLabel="searchOptions.searchLabel"
      :headers="searchOptions.headers"
      :filterString="searchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import Person from "@/components/Person.vue";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";

export default {
  name: "CommercialPersonEdit",

  components: {
    Person,
    PaginatedSearchDialog
  },

  props: ["value", "initialmode"],

  data: () => ({
    currentTab: 0,
    current_level: null,
    editing: false,
    mode: null,
    object: null,
    commercialPersonTypes: null,
    showSuperior: false,
    showSalesman: false,
    showClient: false,
    enabledPersonManual: false,
    searchOptions: {}
  }),

  methods: {
    async personSelected(person) {
      try {
        if (!person.identification_type_code) {
          person = await this.$bRoot.getObjectByURL(person.url);
        }
        //tryNew
        let response = await this.$bRoot.search(
          "/data/commercial_persons",
          null,
          null,
          "person__identification_type__code=" +
            person.identification_type_code +
            "&person__identification=" +
            person.identification
        );
        if (response.data.results.length > 0) {
          // edit commercial
          this.mode = "edit";
          this.beginEdit(response.data.results[0].url);
        } else {
          // new commercial
          this.mode = "new";
          this.initialize(person);
          this.currentTab = 1;
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
        this.$emit("endEdit");
      }
    },

    async beginEdit(commercial_person_url) {
      try {
        let cp = await this.$bRoot.getObjectByURL(commercial_person_url);
        if (cp) {
          if (
            //cant edit data of superior level
            this.current_level != 0 &&
            cp.commercial_person_type_level < this.current_level &&
            this.$bRoot.appInfo.commercial_person.url != commercial_person_url
          ) {
            throw "El registro ya existe";
          } else {
            //verifi hierarchy
            let response = await this.$bRoot.search(
              "/data/commercial_persons_hierarchy",
              null,
              null,
              "identification_type_code=" +
                cp.person_identification_type_code +
                "&identification=" +
                cp.person_identification
            );
            if (response.data.results.length === 0) {
              // CommercialPersonExists but user does not have permissions to edit it
              throw "El registro ya existe";
            } else {
              this.object = cp;
              if (
                this.mode === "edit" &&
                this.$bRoot.appInfo.commercial_person.url ===
                  commercial_person_url
              ) {
                this.mode = "show";
              }
              this.editing = this.mode === "edit" || this.mode == "new";
              this.currentTab = 1;
            }
          }
        } else {
          throw "Error recuperando datos de comercial";
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
        this.$emit("endEdit");
      }
    },

    initialize(person) {
      let type = this.commercialPersonTypes[0];
      this.object = {
        id: null,
        url: null,
        person_identification_type_code: person.identification_type_code,
        person_identification_type_description:
          person.identification_type_description,
        person_identification: person.identification,
        person_name: person.name,
        commercial_person_type_id: type.id,
        commercial_person_type_description: type.description,
        commercial_person_type_level: type.level,
        commercial_person_type_requires_client: type.requires_client,
        commercial_person_type_requires_salesman: type.requires_salesman,
        superior_person_name: this.$bRoot.appInfo.commercial_person.person.name,
        // eslint-disable-next-line
        superior_commercial_person_type_description: this.$bRoot.appInfo.commercial_person.commercial_person_type.description,
        // eslint-disable-next-line
        superior_commercial_person_type_level: this.$bRoot.appInfo.commercial_person.commercial_person_type.level,
        salesman_code: null,
        salesman_description: null,
        client_name: null,
        client_code: null,
        email: null,
        can_authenticate: false,
        person: person.url,
        commercial_person_type: type.url,
        superior: this.$bRoot.appInfo.commercial_person.url,
        client: null,
        salesmann: null
      };
    },

    superiorClick() {
      if (this.object.superior) {
        //remuve superior
        this.object.superior = null;
        this.object.superior_commercial_person_type_description = null;
        this.object.superior_commercial_person_type_level = null;
        this.object.superior_person_name = null;
      } else {
        //add superior
        this.searchOptions = {
          headers: [
            { text: "Nombre", value: "name", sortable: false },
            {
              text: "Tipo Identificación",
              value: "identification_type_code",
              sortable: false
            },
            // eslint-disable-next-line
            { text: "Nro.Identificación", value: "identification", sortable: false },
            // eslint-disable-next-line
            { text: "Tipo", value: "commercial_type_description", sortable: false },
          ],
          title: "Superior",
          endpoint: "data/commercial_persons_hierarchy",
          ordering: "name",
          searchLabel: "Nombre/CUIT",
          filterString:
            "commercial_type_level=" +
            (parseInt(this.object.commercial_person_type_level) - 1).toString()
        };
        this.showSuperior = true;
      }
    },

    salesmanClick() {
      if (this.object.salesman) {
        //remuve salesman
        this.object.salesman = null;
        this.object.salesman_code = null;
        this.object.salesman_description = null;
      } else {
        //add salesman
        this.searchOptions = {
          headers: [
            { text: "Nombre", value: "description", sortable: false },
            { text: "Código", value: "code", sortable: false }
          ],
          title: "Vendedor",
          endpoint: "data/salesmans",
          ordering: "description",
          searchLabel: "Nombre/Código",
          filterString: null
        };
        this.showSalesman = true;
      }
    },

    clientClick() {
      if (this.object.client) {
        //remuve client
        this.object.client = null;
        this.object.client_code = null;
        this.object.client_name = null;
      } else {
        //add client
        this.searchOptions = {
          headers: [
            { text: "Nombre", value: "name", sortable: false },
            { text: "Código", value: "code", sortable: false },
            // eslint-disable-next-line
            { text: "Identificación", value: "person_identification", sortable: false }
          ],
          title: "Cliente",
          endpoint: "data/clients",
          ordering: "name",
          searchLabel: "Nombre/Código",
          filterString: null
        };
        this.showClient = true;
      }
    },

    searchSelected(data) {
      if (this.showSuperior) {
        this.superiorSelected(data);
      } else if (this.showSalesman) {
        this.salesmanSelected(data);
      } else if (this.showClient) {
        this.clientSelected(data);
      }
    },

    superiorSelected(data) {
      this.showSuperior = false;
      this.searchOptions = {};
      this.object.superior = data.commercial_person;
      this.object.superior_commercial_person_type_description =
        data.commercial_type_description;
      this.object.superior_commercial_person_type_level =
        data.commercial_type_level;
      this.object.superior_person_name = data.name;
      this.object.superior_can_view_orders = data.can_view_orders;
      this.object.superior_can_edit_orders = data.can_edit_orders;
      this.object.superior_can_access_quotations = data.can_access_quotations;
    },

    salesmanSelected(data) {
      this.showSalesman = false;
      this.searchOptions = {};
      this.object.salesman = data.url;
      this.object.salesman_code = data.code;
      this.object.salesman_description = data.description;
    },

    clientSelected(data) {
      this.showClient = false;
      this.searchOptions = {};
      this.object.client = data.url;
      this.object.client_code = data.code;
      this.object.client_name = data.name;
    },

    CommercialPersonTypeChange(typeUrl) {
      let index = this.commercialPersonTypes.findIndex(
        cpt => cpt.url === typeUrl
      );
      // eslint-disable-next-line
      this.object.commercial_person_type_level = this.commercialPersonTypes[index].level;
      // eslint-disable-next-line
      this.object.commercial_person_type_requires_client = this.commercialPersonTypes[index].requires_client;
      // eslint-disable-next-line
      this.object.commercial_person_type_requires_salesman = this.commercialPersonTypes[index].requires_salesman;
    },

    searchCanceled() {
      this.showSuperior = false;
      this.showSalesman = false;
      this.showClient = false;
      this.searchOptions = {};
    },

    async save() {
      try {
        //validate commercial_person information
        if (this.$bRoot.isNullOrEmpty(this.object, "person")) {
          throw "El dato persona es obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(this.object, "person")) {
          throw "El dato persona es obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(this.object, "commercial_person_type")) {
          throw "El dato persona es obligatorio";
        }
        if (
          this.object.commercial_person_type_level > 0 &&
          this.$bRoot.isNullOrEmpty(this.object, "superior")
        ) {
          throw "El dato superior es obligatorio";
        }
        if (
          this.object.commercial_person_type_level > 0 &&
          this.object.commercial_person_type_level -
            this.object.superior_commercial_person_type_level !==
            1
        ) {
          throw "Superior mal definido, jerarquía incorrecta";
        }
        if (
          this.object.commercial_person_type_requires_client === true &&
          this.$bRoot.isNullOrEmpty(this.object, "client")
        ) {
          throw "El tipo de comercial requiere que asocie una cuenta de cliente";
        }
        if (
          this.object.commercial_person_type_requires_salesman === true &&
          this.$bRoot.isNullOrEmpty(this.object, "salesman")
        ) {
          throw "El tipo de comercial requiere que asocie código de vendedor";
        }
        if (this.object.id) {
          if (this.object.commercial_person_type_level !== 3) {
            let surveys = await this.$bRoot.search(
              "/data/surveys",
              null,
              null,
              "commercial_person__id=" + this.object.id.toString()
            );
            if (surveys.data.results.length > 0) {
              throw "Comercial posee relevamientos asignados, no puede modificar jerarquía";
            }
          }
          let dependants = await this.$bRoot.search(
            "/data/commercial_persons",
            null,
            null,
            "superior__id=" +
              this.object.id.toString() +
              "&commercial_person_type__level__lte=" +
              this.object.commercial_person_type_level.toString()
          );
          if (dependants.data.results.length > 0) {
            throw "Comercial posee dependientes de jerarquía equivalente o superior";
          }
          dependants = await this.$bRoot.search(
            "/data/commercial_persons",
            null,
            null,
            "superior__id=" +
              this.object.id.toString() +
              "&commercial_person_type__level__gte=" +
              (this.object.commercial_person_type_level + 2).toString()
          );
          if (dependants.data.results.length > 0) {
            throw "Comercial posee dependientes de jerarquía inferior a la correcta";
          }
        }
        let object = {
          person: this.object.person,
          email: this.object.email,
          phone_number: this.object.phone_number,
          can_authenticate: this.object.can_authenticate,
          can_estimate_sale: this.object.commercial_person_type_level <= 3 ? true : this.object.can_estimate_sale, //eslint-disable-line
          can_view_orders: this.object.can_view_orders,
          can_edit_orders: this.object.can_edit_orders,
          can_access_quotations: this.object.can_access_quotations,
          commercial_person_type: this.object.commercial_person_type,
          superior: this.object.superior,
          client: this.object.commercial_person_type_requires_client
            ? this.object.client
            : null,
          salesman: this.object.commercial_person_type_requires_salesman
            ? this.object.salesman
            : null
        };
        if (this.object.url) {
          object.url = this.object.url;
        }
        if (this.object.user) {
          object.user = this.object.user;
        }
        let added = null;
        if (object.url) {
          added = await this.$bRoot.save(object);
        } else {
          added = await this.$bRoot.add(
            "/data/commercial_persons",
            "person__identification_type__code=" +
              this.object.person_identification_type_code +
              "&person__identification=" +
              this.object.person_identification,
            object
          );
        }
        if (added) {
          this.$emit("endEdit");
        } else {
          throw "El registro no se guardo";
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
          return null;
        }
      }
    }
  },

  mounted() {
    this.currentTab = this.value ? 1 : 0;
    this.mode = this.initialmode;
    this.current_level = this.$bRoot.auth.current_level;
    this.enabledPersonManual = (this.current_level <= 2 ? true : false); //eslint-disable-line
    let fromlevel = this.current_level - (this.current_level === 0 ? 1 : 0);
    if (!this.commercialPersonTypes) {
      // eslint-disable-next-line
      this.$bRoot.search("data/commercial_person_types", null, 'level', 'level__gt=' + fromlevel.toString())
        .then(response => {
          if (response["data"]) {
            this.commercialPersonTypes = response.data.results;
            if (this.value) {
              this.beginEdit(this.value);
            }
            this.editing = this.mode === "edit" || this.mode == "new";
          }
        })
        .catch(error => {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(error);
          }
          this.mode = "show";
          this.editing = false;
        });
    }
  },

  watch: {
    mode: {
      handler() {
        this.$emit("modeChange", this.mode);
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
